import { render } from "./LegislatiePage.vue?vue&type=template&id=de158b0a"
import script from "./LegislatiePage.vue?vue&type=script&lang=js"
export * from "./LegislatiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__